<template>
  <div class="order-payment">
    <iframe allow="payment" title="payment-form" :src="updatedLink" />
  </div>
</template>

<script>
export default {
  name: 'Payment',
  props: {
    link: {
      default: null,
      type: String,
    },
  },
  computed: {
    updatedLink() {
      if (!this.link) return null;

      const url = new URL(this.link);
      const parentDomain = encodeURIComponent(window.location.hostname);
      url.searchParams.set('parent-domain', parentDomain);

      return url.toString();
    },
  },
};
</script>
